import { Routes } from '@angular/router';

export const contentModerationRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'portfolios',
      },

      {
        path: 'services',
        loadComponent: () =>
          import('./services-content/services-content').then((m) => m.ServicesContent),
      },

      {
        path: 'services/:id',
        data: { context: 'content-moderation' },
        loadComponent: () =>
          import('../pending-approvals/services-approvals/service-details/service-details').then(
            (m) => m.ServiceDetails,
          ),
      },

      {
        path: 'portfolios',
        loadComponent: () => import('./portfolios/portfolios').then((m) => m.Portfolios),
      },

      {
        path: 'portfolios/:id',
        loadComponent: () =>
          import('./portfolios/portfolio-details/portfolio-details').then(
            (m) => m.PortfolioDetails,
          ),
      },

      {
        path: 'service-requests',
        loadComponent: () =>
          import('./service-request/service-request').then((m) => m.ServiceRequest),
      },

      {
        path: 'service-requests/:id',
        loadComponent: () =>
          import('./service-request/service-request-details/service-request-details').then(
            (m) => m.ServiceRequestDetails,
          ),
      },
      {
        path: 'projects',
        loadComponent: () =>
          import('./projects/projects').then((m) => m.Projects),
      },

      {
        path: 'projects/:id',
        loadComponent: () =>
          import('./projects/project-details/project-details').then(
            (m) => m.ProjectDetails,
          ),
      },
    ],
  },
];
